"use client"
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { FiUser, FiCalendar, FiArrowRight } from 'react-icons/fi';

const EnhancedBlogCard = ({
  author,
  topic,
  title,
  brief,
  date = 'May 3, 2024',
  imageUrl,
  linkUrl,
}) => {
  return (
    <div className="group relative overflow-hidden rounded-lg shadow-md transition-all duration-300 hover:shadow-xl transform hover:-translate-y-1 bg-white w-full max-w-sm">
      {/* Category badge */}
      <div className="absolute top-4 left-4 z-10">
        <span className="px-3 py-1 rounded-full text-xs font-semibold bg-blue-600 text-white shadow-sm">
          {topic}
        </span>
      </div>
      
      {/* Image section */}
      <div className="relative h-56 overflow-hidden">
        <Image
          src={imageUrl}
          fill
          style={{ objectFit: 'cover' }}
          alt={title}
          className="transition-transform duration-700 ease-in-out group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-70"></div>
      </div>
      
      {/* Content section */}
      <div className="p-5">
        <h3 className="text-xl font-bold text-gray-800 line-clamp-2 mb-2 group-hover:text-blue-600 transition-colors">
          {title}
        </h3>
        
        <p className="text-gray-600 line-clamp-3 mb-4 text-sm">
          {brief}
        </p>
        
        <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
          <div className="flex items-center">
            <FiUser className="mr-1" size={14} />
            <span>{author}</span>
          </div>
          <div className="flex items-center">
            <FiCalendar className="mr-1" size={14} />
            <span>{date}</span>
          </div>
        </div>
        
        <Link href={linkUrl} passHref>
          <div className="inline-flex items-center text-blue-600 font-medium text-sm group-hover:text-blue-700">
            Read more
            <FiArrowRight className="ml-2 transition-transform group-hover:translate-x-1" />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default EnhancedBlogCard; 